<template>
  <div>
    <h1>Dashboard Sistemas</h1>
  </div>
</template>

<script>
export default {
  name: 'DashboardSistemas'
}
</script>